import React, { useRef } from 'react';
var VeltNotificationsPanelContentAllListItemContent = function (props) {
    var date = props.date, defaultCondition = props.defaultCondition, children = props.children;
    var ref = useRef(null);
    return (React.createElement("velt-notifications-panel-content-all-list-item-content", { ref: ref, date: date, "default-condition": [true, false].includes(defaultCondition) ? (defaultCondition ? 'true' : 'false') : undefined }, children));
};
export default VeltNotificationsPanelContentAllListItemContent;
